import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, deleteObject } from 'firebase/storage';
import { post } from './api';

export const uploadFileToFirebase = async ({ fileName, file, folderName = '', metadata = {} }) => {
  try {
    const firebaseConfig = await post('/api/firebase/get-config', {});
    const app = initializeApp(firebaseConfig);
    const storage = getStorage(app);
    const fileRef = ref(storage, `${folderName}${fileName}`);
    const uploadedFile = await uploadBytes(fileRef, file, metadata);
    return uploadedFile;
  } catch (e) {
    throw e;
  }
};

export const downloadFileFromFirebase = async ({ fileName, folderName = '' }) => {
  try {
    if (typeof window !== 'undefined') {
      const { url } = await post('/api/firebase/get-download-url', {
        filePath: `/${folderName}/${fileName}`,
      });
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.target = '_blank';
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getDownloadUrlFromFirebase = async ({ fileName, folderName = '' }) => {
  try {
    const downloadUrl = await post('/api/firebase/get-download-url', {
      filePath: `/${folderName}/${fileName}`,
    });
    return downloadUrl;
  } catch (e) {
    throw e;
  }
};

export const deleteFileFromFirebase = async ({ fileName, folderName = '' }) => {
  try {
    const firebaseConfig = await post('/api/firebase/get-config', {});
    const app = initializeApp(firebaseConfig);
    const storage = getStorage(app);
    const fileRef = ref(storage, `${folderName}${fileName}`);
    await deleteObject(fileRef);
    return { success: true };
  } catch (e) {
    // If file doesn't exist, that's okay - we can consider it already deleted
    if (e.code === 'storage/object-not-found') {
      return { success: true, alreadyDeleted: true };
    }
    console.error('Error deleting file from Firebase:', e);
    throw e;
  }
};
